import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import './assets/element-variables.scss'
import '@/permission' // permission control

// 引入响应式库bootstarp
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min'

// 全局屏蔽 alert/confirm/prompt 弹窗，避免打断视频播放等用户体验
// 将弹窗改为控制台输出，方便调试但不阻塞用户操作
window.alert = function(msg) {
    console.log('[Alert]', msg);
};
window.confirm = function(msg) {
    console.log('[Confirm]', msg);
    return true; // 直接返回true，避免阻塞
};
window.prompt = function(msg, defaultValue) {
    console.log('[Prompt]', msg, defaultValue);
    return defaultValue || '';
};

Vue.use(ElementUI);


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
